
import { Link, useLocation } from "react-router-dom";
import { NavigationItem } from "./NavigationItems";

interface DesktopNavigationLinksProps {
  items: NavigationItem[];
}

export function DesktopNavigationLinks({ items }: DesktopNavigationLinksProps) {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path ? "text-primary" : "text-muted-foreground";
  };

  // Filter out profile for desktop nav as it's shown in the user section
  const desktopItems = items.filter(item => item.path !== "/profile");

  return (
    <div className="flex items-center space-x-1">
      {desktopItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`${isActive(item.path)} px-3 py-1.5 text-sm rounded-md hover:bg-muted transition-colors flex items-center gap-2 whitespace-nowrap`}
        >
          <item.icon className="w-4 h-4" />
          {item.label}
        </Link>
      ))}
    </div>
  );
}
